import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UserApiService } from 'shared/services/userApi.service';
import { unsubscribeFromAll } from 'shared/util/unsubscribeFromAll';

@Component({
    selector: 'app-forgot-password-form',
    templateUrl: './forgot-password-form.component.html',
    styleUrls: ['./forgot-password-form.component.scss', '../../authentication.scss'],
    standalone: false,
})
export class ForgotPasswordFormComponent implements OnDestroy {
    private subscriptions: { [key: string]: Subscription | undefined } = {};
    isResetPasswordEmailSent: boolean = false;
    forgotPasswordForm!: UntypedFormGroup;

    constructor(private userApiService: UserApiService) {
        this.forgotPasswordForm = new UntypedFormGroup({
            email: new UntypedFormControl('', [Validators.required, Validators.email]),
        });
    }

    public ngOnDestroy(): void {
        unsubscribeFromAll(this.subscriptions);
    }

    public recoverPassword() {
        this.forgotPasswordForm.markAllAsTouched();
        this.forgotPasswordForm.get('email')?.updateValueAndValidity();

        if (this.forgotPasswordForm.valid) {
            this.subscriptions.forgotPassword = this.userApiService.addRequest(this.forgotPasswordForm.value.email, 2).subscribe(() => {
                this.isResetPasswordEmailSent = true;
            });
        }
    }
}
